import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { FormSection, reduxForm } from "redux-form";
import styled from "styled-components";
import { aseFieldLabelMapping } from "../../../../constants/aseFieldLabelMapping";
import {
    DOCUMENTATION_UPDATE_SECTION,
    FORM_ATTACHMENTS_SECTION,
    FORM_MESSAGES_SECTION,
    FORM_PROBLEM_DESCRIPTION_SECTION,
    FORM_TICKET_SECTION,
} from "../../../../constants/formConstants";
import formMessages from "../../../../intl/afterSales/formMessages";
import { scrollContentWrapperToTop } from "../../../../utils/utils";
import RenderSyncErrors from "../../../common/RenderSyncErrors";
import TicketStatusHistory from "../../../common/TicketStatusHistory";
import AttachmentSection from "./sections/attachments/AttachmentSection";
import InternalNotes from "./sections/internalNotes/InternalNotes";
import SubmitButtons from "./sections/SubmitButtons";
import DocumentationUpdateSection from "./sections/technicalBulletin/DocumentationUpdateSection";
import ProblemDescriptionSection from "./sections/technicalBulletin/ProblemDescriptionSection";
import RequestorInformationSection from "./sections/technicalBulletin/RequestorInformationSection";

const StyledDiv = styled.div`
    border-radius: 10px;
    background-color: #fffae6 !important;
`;

const InternalTechnicalBulletinTicketMasterForm = (props) => {
    const {
        form,
        userRights,
        readOnly,
        handleSubmit,
        reqFields,
        showDocumentationUpdate,
    } = props;

    return (
        <StyledDiv className="border border-dark p-4">
            <RenderSyncErrors
                form={form}
                intlMessages={formMessages}
                mapping={aseFieldLabelMapping}
            />
            <FormSection name={FORM_TICKET_SECTION}>
                <RequestorInformationSection
                    form={form}
                    userRights={userRights}
                    reqFields={reqFields}
                    readOnly={readOnly}
                />
            </FormSection>
            <FormSection name={FORM_PROBLEM_DESCRIPTION_SECTION}>
                <ProblemDescriptionSection
                    form={form}
                    userRights={userRights}
                    reqFields={reqFields}
                    readOnly={readOnly}
                />
            </FormSection>
            {userRights.canShowInternalNotes && (
                <FormSection name={FORM_MESSAGES_SECTION}>
                    <InternalNotes
                        form={form}
                        userRights={userRights}
                        reqFields={reqFields}
                        readOnly={readOnly}
                    />
                </FormSection>
            )}
            {showDocumentationUpdate && (
                <FormSection name={DOCUMENTATION_UPDATE_SECTION}>
                    <DocumentationUpdateSection
                        form={form}
                        userRights={userRights}
                        reqFields={reqFields}
                        readOnly={readOnly}
                    />
                </FormSection>
            )}
            <TicketStatusHistory form={form} isInternal />
            <FormSection name={FORM_ATTACHMENTS_SECTION}>
                <AttachmentSection
                    form={form}
                    userRights={userRights}
                    readOnly={readOnly}
                />
            </FormSection>
            <SubmitButtons
                form={form}
                onSubmit={handleSubmit}
                onSubmitFail={scrollContentWrapperToTop}
                userRights={userRights}
                readOnly={readOnly}
            />
        </StyledDiv>
    );
};

InternalTechnicalBulletinTicketMasterForm.propTypes = {
    form: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func,
    readOnly: PropTypes.bool,
    userRights: PropTypes.object.isRequired,
    reqFields: PropTypes.array.isRequired,
    showDocumentationUpdate: PropTypes.bool,
};

const mapStateToProps = (state, props) => ({});

const mapDispatchToProps = (dispatch, props) => ({});

export default reduxForm({})(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(InternalTechnicalBulletinTicketMasterForm),
);

